export const cloneControl = {
  defaultButton: `Klonuj`,
  defaultNoun: `ustawienia`,
  itemNounDefault: `te ustawienia`,
  pullTitle: `Pobierz ustawienia z innej oferty`,
  pushTitle: `Skopiuj te ustawienia do innej oferty`,
  pullSubReplace: `Zostaną zastosowane w tej ofercie`,
  pullSubAdd: `Zostaną dodane do tej oferty`,
  pushSubReplace: `Zostaną zastosowane w wybranych ofertach`,
  pushSubAdd: `Zostaną dodane do wybranych ofert`,
  pullTitleFull: `Pobierz: {noun}`,
  pushTitleFull: `Skopiuj: {noun}`,
  pullSubtitle: `Proszę wybrać ofertę, z której mają zostać pobrane ustawienia. Zostaną zastosowane w tej ofercie.`,
  pushSubtitle: `Te ustawienia zostaną skopiowane do wybranych ofert.`,
};
